import React from "react";
import { Clock, MapPin, ShieldCheck } from "lucide-react";
const pillars = [{
  title: "24/7 Emergency Plumbing",
  icon: Clock
}, {
  title: "Local Central Coast Plumber",
  icon: MapPin
}, {
  title: "Licensed & Experienced",
  icon: ShieldCheck
}];
export default function OurTrustPillars() {
  return <section id="our-trust-pillars" className="relative z-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto -mt-12 sm:-mt-16 mb-16 sm:mb-24">
      <div className="bg-secondary border border-border/60 rounded-2xl shadow-lg shadow-shadow-color/5 flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x divide-border/60 overflow-hidden">
        {pillars.map((pillar, i) => {
        const Icon = pillar.icon;
        return <div key={i} data-index={i} className="flex-1 p-6 sm:p-8 flex items-center justify-center bg-secondary/50 backdrop-blur-sm">
              <div className="flex items-center gap-4 group cursor-default transition-transform duration-300 hover:-translate-y-1 w-full justify-center md:justify-start lg:justify-center">
                <Icon className="size-8 text-primary transition-colors duration-300 group-hover:text-chart-2 shrink-0" strokeWidth={1.5} />
                <span className="font-bold text-base text-foreground tracking-tight">
                  {pillar.title}
                </span>
              </div>
            </div>;
      })}
      </div>
    </section>;
}